<div class="p-20 fx-row fx-wrap align-items-center justify-content-center">
    <div class="fx-flex-100 align-items-center justify-content-center text-center">
        <span class="title mb-10 text-center">{{'ORGANIZATION.ANALYZER_CONFIGURATION.EDIT_CONFIGURATION' |
            translate}}</span>
    </div>
    <span class="text mv-20"
        *ngIf="organization">{{'ORGANIZATION.ANALYZER_CONFIGURATION.EDIT_CONFIGURATION_INSTRUCTIONS' |
        translate:organization}}</span>
    <span class="text bold fx-flex-100">
        {{'ORGANIZATION.ANALYZER_CONFIGURATION.DEFAULT_VALUES' | translate}}
    </span>
    <div class="fx-row fx-wrap mt-8 fx-flex-100">
        <span class="text dark fx-flex-100">
            {{'ORGANIZATION.ANALYZER_CONFIGURATION.DEFAULT_VALUES_COUNTRY_GUESSED_FROM_LANG' | translate}}
        </span>
        <span class="small light fx-flex-100">
            {{'ORGANIZATION.ANALYZER_CONFIGURATION.DEFAULT_VALUES_COUNTRY_GUESSED_FROM_LANG_HINT' | translate}}
        </span>
        <div class="mt-8 fx-flex-100 fx-wrap fx-row"
            *ngIf="analyzerConfiguration && analyzerConfiguration.defaultValues && analyzerConfiguration.defaultValues.countryGuessedFromLang != undefined">
            <span class="text main bold fx-flex-100">
                {{(analyzerConfiguration.defaultValues.countryGuessedFromLang*100).toFixed(0)}}%
            </span>
            <mat-slider [max]="0.9" [min]="0.1" [step]="0.01" [discrete]="true" class="fx-flex-100">
                <input matSliderThumb [(ngModel)]="analyzerConfiguration.defaultValues.countryGuessedFromLang" #slider>
            </mat-slider>
        </div>
    </div>
    <div class="fx-row fx-wrap mt-8 fx-flex-100">
        <span class="text dark fx-flex-100">
            {{'ORGANIZATION.ANALYZER_CONFIGURATION.DEFAULT_VALUES_COUNTRY_GUESSED_FROM_LANG_EN' | translate}}
        </span>
        <span class="small light fx-flex-100">
            {{'ORGANIZATION.ANALYZER_CONFIGURATION.DEFAULT_VALUES_COUNTRY_GUESSED_FROM_LANG_EN_HINT' | translate}}
        </span>
        <div class="mt-8 fx-flex-100 fx-wrap fx-row"
            *ngIf="analyzerConfiguration && analyzerConfiguration.defaultValues && analyzerConfiguration.defaultValues.countryGuessedFromLangEN != undefined">
            <span class="text main bold fx-flex-100">
                {{(analyzerConfiguration.defaultValues.countryGuessedFromLangEN*100).toFixed(0)}}%
            </span>
            <mat-slider [max]="0.9" [min]="0.1" [step]="0.01" [discrete]="true" class="fx-flex-100">
                <input matSliderThumb [(ngModel)]="analyzerConfiguration.defaultValues.countryGuessedFromLangEN"
                    #slider>
            </mat-slider>
        </div>
    </div>
    <div class="fx-row fx-wrap mt-8 fx-flex-100">
        <span class="text dark fx-flex-100">
            {{'ORGANIZATION.ANALYZER_CONFIGURATION.DEFAULT_VALUES_OTHER_DOCUMENT_CLASS' | translate}}
        </span>
        <span class="small light fx-flex-100">
            {{'ORGANIZATION.ANALYZER_CONFIGURATION.DEFAULT_VALUES_OTHER_DOCUMENT_CLASS_HINT' | translate}}
        </span>
        <div class="mt-8 fx-flex-100 fx-wrap fx-row"
            *ngIf="analyzerConfiguration && analyzerConfiguration.defaultValues && analyzerConfiguration.defaultValues.otherDocumentClass != undefined">
            <span class="text main bold fx-flex-100">
                {{(analyzerConfiguration.defaultValues.otherDocumentClass*100).toFixed(0)}}%
            </span>
            <mat-slider [max]="0.9" [min]="0.1" [step]="0.01" [discrete]="true" class="fx-flex-100">
                <input matSliderThumb [(ngModel)]="analyzerConfiguration.defaultValues.otherDocumentClass" #slider>
            </mat-slider>
        </div>
    </div>
    <mat-divider class="mv-16 fx-flex-100"></mat-divider>
    <span class="text bold fx-flex-100">
        {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS' | translate}}
    </span>
    <div class="fx-row fx-wrap mt-8 fx-flex-100">
        <span class="text dark fx-flex-100">
            {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS_LOGO_DETECTION' | translate}}
        </span>
        <span class="small light fx-flex-100">
            {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS_LOGO_DETECTION_HINT' | translate}}
        </span>
        <div class="mt-8 fx-flex-100 fx-wrap fx-row"
            *ngIf="analyzerConfiguration && analyzerConfiguration.thresholds && analyzerConfiguration.thresholds.logoDetection != undefined">
            <span class="text main bold fx-flex-100">
                {{(analyzerConfiguration.thresholds.logoDetection*100).toFixed(0)}}%
            </span>
            <mat-slider [max]="0.9" [min]="0.1" [step]="0.01" [discrete]="true" class="fx-flex-100">
                <input matSliderThumb [(ngModel)]="analyzerConfiguration.thresholds.logoDetection" #slider>
            </mat-slider>
        </div>
    </div>
    <div class="fx-row fx-wrap mt-8 fx-flex-100">
        <span class="text dark fx-flex-100">
            {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS_LOGO_DETECTION_IMAGE' | translate}}
        </span>
        <span class="small light fx-flex-100">
            {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS_LOGO_DETECTION_IMAGE_HINT' | translate}}
        </span>
        <div class="mt-8 fx-flex-100 fx-wrap fx-row"
            *ngIf="analyzerConfiguration && analyzerConfiguration.thresholds && analyzerConfiguration.thresholds.logoDetectionImage != undefined">
            <span class="text main bold fx-flex-100">
                {{(analyzerConfiguration.thresholds.logoDetectionImage*100).toFixed(0)}}%
            </span>
            <mat-slider [max]="0.9" [min]="0.1" [step]="0.01" [discrete]="true" class="fx-flex-100">
                <input matSliderThumb [(ngModel)]="analyzerConfiguration.thresholds.logoDetectionImage" #slider>
            </mat-slider>
        </div>
    </div>
    <div class="fx-row fx-wrap mt-8 fx-flex-100">
        <span class="text dark fx-flex-100">
            {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS_IMAGE_SIMILARITY' | translate}}
        </span>
        <span class="small light fx-flex-100">
            {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS_IMAGE_SIMILARITY_HINT' | translate}}
        </span>
        <div class="mt-8 fx-flex-100 fx-wrap fx-row"
            *ngIf="analyzerConfiguration && analyzerConfiguration.thresholds && analyzerConfiguration.thresholds.imageSimilarity != undefined">
            <span class="text main bold fx-flex-100">
                {{(analyzerConfiguration.thresholds.imageSimilarity*100).toFixed(0)}}%
            </span>
            <mat-slider [max]="0.9" [min]="0.1" [step]="0.01" [discrete]="true" class="fx-flex-100">
                <input matSliderThumb [(ngModel)]="analyzerConfiguration.thresholds.imageSimilarity" #slider>
            </mat-slider>
        </div>
    </div>
    <div class="fx-row fx-wrap mt-8 fx-flex-100">
        <span class="text dark fx-flex-100">
            {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS_TEXT_SIMILARITY' | translate}}
        </span>
        <span class="small light fx-flex-100">
            {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS_TEXT_SIMILARITY_HINT' | translate}}
        </span>
        <div class="mt-8 fx-flex-100 fx-wrap fx-row"
            *ngIf="analyzerConfiguration && analyzerConfiguration.thresholds && analyzerConfiguration.thresholds.textSimilarity != undefined">
            <span class="text main bold fx-flex-100">
                {{(analyzerConfiguration.thresholds.textSimilarity*100).toFixed(0)}}%
            </span>
            <mat-slider [max]="0.9" [min]="0.1" [step]="0.01" [discrete]="true" class="fx-flex-100">
                <input matSliderThumb [(ngModel)]="analyzerConfiguration.thresholds.textSimilarity" #slider>
            </mat-slider>
        </div>
    </div>
    <div class="fx-row fx-wrap mt-8 fx-flex-100">
        <span class="text dark fx-flex-100">
            {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS_PS_SIMILARITY' | translate}}
        </span>
        <span class="small light fx-flex-100">
            {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS_PS_SIMILARITY_HINT' | translate}}
        </span>
        <div class="mt-8 fx-flex-100 fx-wrap fx-row"
            *ngIf="analyzerConfiguration && analyzerConfiguration.thresholds && analyzerConfiguration.thresholds.psSimilarity != undefined">
            <span class="text main bold fx-flex-100">
                {{(analyzerConfiguration.thresholds.psSimilarity*100).toFixed(0)}}%
            </span>
            <mat-slider [max]="0.9" [min]="0.1" [step]="0.01" [discrete]="true" class="fx-flex-100">
                <input matSliderThumb [(ngModel)]="analyzerConfiguration.thresholds.psSimilarity" #slider>
            </mat-slider>
        </div>
    </div>
    <mat-divider class="fx-flex-100 mv-20"></mat-divider>
    <div class="fx-row fx-wrap fx-flex-100">
        <button class="button fx-flex-100 mb-8"
            (click)="resetToDefaultValues()">{{'ORGANIZATION.ANALYZER_CONFIGURATION.RESET_TO_DEFAULT_VALUES'
            | translate}}</button>
        <span class="small light fx-flex-100">
            {{'ORGANIZATION.ANALYZER_CONFIGURATION.RESET_TO_DEFAULT_VALUES_HINT' | translate}}
        </span>
    </div>

    <mat-divider class="fx-flex-100 mv-20"></mat-divider>
    <div class="fx-row align-items-center justify-content-center fx-flex-100">
        <button class="button fx-flex mr-10" (click)="onCancel()">{{'ACTIONS.CANCEL' | translate}}</button>
        <button class="main-button fx-flex ml-10" (click)="onSave()">{{'ACTIONS.VALIDATE'
            | translate}}</button>
    </div>
</div>